var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "General settings", {})))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            _vm._s(_vm.t("health", "Price for a cigarette")) +
              _vm._s(
                _vm.person.currency ? " [" + _vm.person.currency + "]" : ""
              )
          )
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          step: "0.1",
          value: _vm.person.smokingPrice,
          icon: "icon-category-customization"
        },
        on: {
          submit: function($event) {
            return _vm.$store.dispatch("setValue", {
              key: "smokingPrice",
              value: $event.target[1].value
            })
          }
        }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            _vm._s(_vm.t("health", "Starting with how many cigarettes a day"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          value: _vm.person.smokingStartValue,
          icon: "icon-category-customization"
        },
        on: {
          submit: function($event) {
            return _vm.$store.dispatch("setValue", {
              key: "smokingStartValue",
              value: $event.target[1].value
            })
          }
        }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v(_vm._s(_vm.t("health", "Goal cigarettes per day")))])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          value: _vm.person.smokingGoal,
          icon: "icon-category-customization"
        },
        on: {
          submit: function($event) {
            return _vm.$store.dispatch("setValue", {
              key: "smokingGoal",
              value: $event.target[1].value
            })
          }
        }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.smokingColumnCigarettes },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "smokingColumnCigarettes",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Cigarettes", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.smokingColumnDesireLevel },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "smokingColumnDesireLevel",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.t("health", "Desire level", {})) + "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.smokingColumnSavedMoney },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "smokingColumnSavedMoney",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Saved money", {})) + "\n\t")]
      ),
      _vm._v(" "),
      !_vm.person.smokingPrice
        ? _c("div", { staticClass: "input-hint" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t(
                    "health",
                    "Please set a price to calculate saved money.",
                    {}
                  )
                ) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.person.smokingStartValue
        ? _c("div", { staticClass: "input-hint" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t(
                    "health",
                    "Please set the number of cigarettes a day you are starting with to calculate saved money.",
                    {}
                  )
                ) +
                "\n\t"
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }